export function resolveMediaUrl(value) {
  if (!value || !value.startsWith("/api/media/assets/")) return value;
  const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${backend}${value}`;
}
